export const ASYNC_STATUS = {
  PENDING: "pending",
  SYNCED: "synced",
};

export const ORDER_STATUS = {
  CLOSED: "CLOSE",
  ACTIVE: "active",
  VOID: "VOID",
  VOID_OLD: "VOID_OLD",
  VOID_BY_BISTRO: "VOID_BY_BISTRO",
  VOID_BY_BISTRO_OLD: "VOID_BY_BISTRO_OLD",
  VOID_NT: "VOID_NT", 
  VOID_NT_OLD: "VOID_NT_OLD", 
};

export const ORDER_TYPE = {
  COMANDA: "COMANDA",
  VOID: "VOID",
  VOID_OLD: "VOID_OLD",
  VENTA: "VENTA", 
  VOID_BY_BISTRO: "VOID_BY_BISTRO", 
  VOID_BY_BISTRO_OLD: "VOID_BY_BISTRO_OLD", 
  VOID_NT: "VOID_NT", 
  VOID_NT_OLD: "VOID_NT_OLD", 
};

export const CARD_STATUS = {
  PRODUCT: "product",
  AVAILABLE: "available", 
  ACTIVE: "active",
  CLOSED: "closed",
};


